<mat-icon matTooltip="{{ 'Common.Filters.FilterDatetime' | translate }}" [matMenuTriggerFor]="menu">filter_alt
</mat-icon>

<mat-menu #menu="matMenu">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <form [formGroup]="filterForm" (click)="$event.stopPropagation();">
          <mat-form-field>
            <mat-label>{{ 'Common.Filters.FilterType' | translate }}</mat-label>
            <mat-select [formControl]="filterTypeControl" [value]="filterTypeControl"
              (selectionChange)="onFilterChange($event)" (click)="$event.stopPropagation();">
              @for (option of filterOptions; track option) {
                <mat-option [value]="option.value"
                  (click)="$event.stopPropagation();">
                  {{ option.translationKey | translate }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </form>
      </div>
    </div>

    @if (this.currentFilter.value !== this.dateFilterBetween) {
      <div class="row">
        <div class="col-12">
          <form [formGroup]="singleDateForm" (click)="$event.stopPropagation();">
            <mat-form-field>
              <mat-label>{{'Common.Filters.Date' | translate }} </mat-label>
              <input matInput [formControl]="dateSingleDateControl" [matDatepicker]="singlePicker"
                (click)="$event.stopPropagation();">
                <mat-datepicker-toggle matSuffix [for]="singlePicker">
                </mat-datepicker-toggle>
                <mat-datepicker #singlePicker startView="month" (click)="$event.stopPropagation();">
                </mat-datepicker>
              </mat-form-field>
            </form>
          </div>
        </div>
      } @else {
        <div class="row">
          <div class="col-12">
            <form [formGroup]="dateBetweenForm" (click)="$event.stopPropagation();">
              <div class="row">
                <div class="col-12">
                  <mat-form-field>
                    <mat-label>{{'Common.Filters.From' | translate }} </mat-label>
                    <input matInput [formControl]="dateBetweenValueControl" [matDatepicker]="fromPicker"
                      (click)="$event.stopPropagation();">
                      <mat-datepicker-toggle matSuffix [for]="fromPicker">
                      </mat-datepicker-toggle>
                      <mat-datepicker #fromPicker startView="month" (click)="$event.stopPropagation();">
                      </mat-datepicker>
                    </mat-form-field>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <mat-form-field>
                      <mat-label>{{'Common.Filters.To' | translate }} </mat-label>
                      <input matInput [formControl]="dateBetweenValue2Control" [matDatepicker]="toPicker"
                        (click)="$event.stopPropagation();">
                        <mat-datepicker-toggle matSuffix [for]="toPicker">
                        </mat-datepicker-toggle>
                        <mat-datepicker #toPicker startView="month" (click)="$event.stopPropagation();">
                        </mat-datepicker>
                      </mat-form-field>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          }


          <div class="row">
            <div class="col" style="display: flex; justify-content: flex-end;">
              <mat-icon matTooltip="{{ 'Common.Filters.Cancel' | translate }}" class="cursor-pointer"
                color="primary" (click)="onCancel()">
                clear
              </mat-icon>
              <mat-icon matTooltip="{{ 'Common.Filters.RunFilter' | translate }}" class="cursor-pointer"
                color="primary" (click)="onSubmit($event)">
                check
              </mat-icon>
              @if (this.currentValue | async) {
                <mat-icon matTooltip="{{ 'Common.Filters.Clear' | translate }}" class="cursor-pointer" color="primary"
                  (click)="onClear()">
                  delete
                </mat-icon>
              }
            </div>
          </div>
        </div>
      </mat-menu>
